const deliveryDetailsActions = {
    types: {
        LOAD_DELIVERY_DETAILS_SUCCESS: 'LOAD_DELIVERY_DETAILS_SUCCESS',
        LOAD_DELIVERY_DETAILS_FAILURE: 'LOAD_DELIVERY_DETAILS_FAILURE',
    },

    deliveryDetailsLoadSuccess(deliveryDetails) {
        return { type: this.types.LOAD_DELIVERY_DETAILS_SUCCESS, deliveryDetails };
    },

    deliveryDetailsLoadFailure(deliveryDetails) {
        return { type: this.types.LOAD_DELIVERY_DETAILS_FAILURE, deliveryDetails };
    },
};

export default deliveryDetailsActions;
